var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.92489 0.637451L9.07489 0.637451C9.67072 0.637451 10.1582 1.12495 10.1582 1.72078V2.91245C10.1582 3.34578 9.88739 3.88745 9.61655 4.15828L7.28739 6.21662C6.96239 6.48745 6.74572 7.02912 6.74572 7.46245L6.74572 9.79162C6.74572 10.1166 6.52905 10.55 6.25822 10.7125L5.49989 11.2C4.79572 11.6333 3.82072 11.1458 3.82072 10.2791L3.82072 7.40828C3.82072 7.02912 3.60405 6.54162 3.38739 6.27078L1.32905 4.10412C1.05822 3.83328 0.841553 3.34578 0.841553 3.02078L0.841553 1.77495C0.841553 1.12495 1.32905 0.637451 1.92489 0.637451Z",
    stroke: "#797D8A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.1b82bb202041fbcdd7dfb5c277939cd0.svg";
export { ForwardRef as ReactComponent };